<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h1 class="text-h4 mb-4">Mes candidatures</h1>
        <p class="text-subtitle-1 text-grey mb-6">
          Consultez l'historique de vos candidatures
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>Candidatures en cours</v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item v-for="application in applications" :key="application.id"
                @click="viewApplication(application)" class="cursor-pointer">
                <template v-slot:prepend>
                  <v-avatar :color="getStatusColor(application.status)">
                    <v-icon>{{ getStatusIcon(application.status) }}</v-icon>
                  </v-avatar>
                </template>

                <v-list-item-title>{{ application.jobTitle }}</v-list-item-title>
                <v-list-item-subtitle>
                  Candidature du {{ formatDate(application.appliedAt) }}
                </v-list-item-subtitle>

                <template v-slot:append>
                  <v-chip :color="getStatusColor(application.status)" size="small">
                    {{ getStatusText(application.status) }}
                  </v-chip>
                </template>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { format } from 'date-fns'
import { fr } from 'date-fns/locale'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const applications = ref([
  {
    id: 1,
    jobTitle: 'Développeur Full Stack Senior',
    status: 'interview',
    appliedAt: new Date('2024-01-15')
  },
  {
    id: 2,
    jobTitle: 'Chef de projet Marketing',
    status: 'pending',
    appliedAt: new Date('2024-01-10')
  }
])

const getStatusColor = (status) => {
  const colors = {
    pending: 'warning',
    interview: 'primary',
    accepted: 'success',
    rejected: 'error'
  }
  return colors[status] || 'grey'
}

const getStatusIcon = (status) => {
  const icons = {
    pending: 'mdi-clock-outline',
    interview: 'mdi-calendar-account',
    accepted: 'mdi-check-circle',
    rejected: 'mdi-close-circle'
  }
  return icons[status] || 'mdi-help-circle'
}

const getStatusText = (status) => {
  const texts = {
    pending: 'En attente',
    interview: 'Entretien',
    accepted: 'Accepté',
    rejected: 'Rejeté'
  }
  return texts[status] || status
}

const formatDate = (date) => {
  return format(new Date(date), 'dd/MM/yyyy', { locale: fr })
}

const viewApplication = (application) => {
  router.push('/candidate/status')
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
